

const initialState = {
    AllusersGroups:[]
  
  }
  
  const userGroupReducer = (state = initialState, action) => {
    const { type, payload } = action
    
    switch (type) {
      case 'SET_USER_GROUP': {
        return {
          ...state,
          AllusersGroups: payload,
        
        }
      }
  
    
  
  
  
      default:
        return state
    }
  }
  
  export default userGroupReducer